import InsertPageBreakIcon from '@mui/icons-material/InsertPageBreak'
import { Avatar, Box, Typography } from '@mui/material'
import { MButton } from 'components'
import { ROUTES_PATH } from 'config'
import { color } from 'config/color'
import { useNavigate } from 'react-router-dom'
export const PaperlessBilling: React.FC = () => {
  const navigate = useNavigate()


  return (
    <Box borderRadius={1} display="flex" flexDirection="column" gap={2} bgcolor={color.white} p={5.5} justifyContent="center" alignItems="center" textAlign="center" sx={{ cursor: 'pointer' }} onClick={() => { navigate(ROUTES_PATH.SETTINGS) }}>
      <Avatar sx={{ background: color.background[50], p: 2 }}>
        <InsertPageBreakIcon
          sx={{ color: color.primary[600], fontSize: 40 }}
        />
      </Avatar>
      <Box>
        <Typography color={color.grey[700]} fontSize={18}>
          Go to Settings
        </Typography>
        <Typography color={color.grey[900]} fontWeight={700} fontSize={32} textAlign="center">
          Paperless Billing
        </Typography>
        <Typography color={color.grey[700]} fontSize={14} textAlign="center">
          More convenience less clutter
        </Typography>
      </Box>
      <MButton
        variant="outlined"
        texttransform="none"
        rounded="true"
        sx={{ width: '75%' }}
        size="large"
      >
        Go to Paperless Billing
      </MButton>
    </Box>
  )
}
